const mAccessDenied = {
  mAccessDenied: {
    link: 'Volver atrás',

    title: {
      first: 'Oops!',
      second: 'No tienes permitido el acceso a esta página.'
    }
  }
}

export default mAccessDenied
